import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRounded: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRounded"><Path d="M2.5 7.5V19.5H19.5M17 4L20.5 7.5L17 11M7.5 13.5V12.5C7.5 9.73858 9.73858 7.5 12.5 7.5H20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRounded;
